{#if notificationStack?.length}
  <div class="cms-tw" transition:fade|local id="jolojo-notifications">
    {#each notificationStack || [] as notification, i (notification?.id)}
      <div on:click={handleNotificationClick(notification)}
        on:mouseover={handleMouseOver}
        on:focus={handleMouseOver}
        on:mouseleave={handleMouseLeave}
        on:blur={handleMouseLeave}
        transition:fly|local={{ x: 30, duration: 300 }}
        animate:flip={{ delay: 300, duration: 300, easing: quintOut }}
        class="jolojo-notification relative bg-gradient-to-t from-gray-50 to-white font-semibold rounded-3xl shadow-md {getPositionClass(notification.position)} {notification.type} {notification?.link ? 'cursor-pointer' : ''}
          {getClass(notification.type)}"
      >
        {#if !notification?.notDismissable}
          <div class="jolojo-notification__close" on:click={removeNotification(notification.id)}>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
          </div>
        {/if}
        {#if thumbnail !== ''}
          <div class="">
            <img src="{thumbnail}" alt="thumbnail" />
          </div>
        {:else if icon === 'loading'}
          <span class="button-icon absolute right-2 top-1/2 transform -translate-y-1/2">
            <svg class="spinner" viewBox="0 0 50 50">
              <circle class="spinner-path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
            </svg>
          </span>
        {:else if icon !== ''}
          {@html icon}
        {/if}
        <div class="font-bold">
          {notification.message}
        </div>
      </div>
    {/each}
  </div>
{/if}

<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};
  export const classNames = ['cms-tw']
</script>
<script>
  import { flip } from 'svelte/animate'
  import { quintOut } from 'svelte/easing'
  import { fly, fade } from 'svelte/transition'
  import { onMount, getContext } from 'svelte'
  export let notification = null
  export let duration = 10_000

  const platform = getContext('platform')
  const notifications = platform.api.core.store('jolojo.notifications')
  const notificationToRemove = platform.api.core.store('jolojo.notificationToRemove')
  const icon = ''
  const thumbnail = ''

  let notificationStack = []
  let intervalStarted = false
  let removeNotifications = null
  let isHoveringOver = false

  $notifications = []

  $: if ($notificationToRemove) {
    removeNotification($notificationToRemove.id)
  }

  // picks up the new notification prop and sends it
  // to the stack
  $: if (notification) {
    sendNotification(notification)
  }

  $: if (notificationStack?.length || isHoveringOver) {
    // start interval when stack is not empty and interval
    // hasn't already been started
    if (!intervalStarted) {
      intervalStarted = true
      removeNotifications = setInterval(() => {
        if (notificationStack[0]?.notDismissable) {
          notificationStack.splice(1, 1)
        } else {
          notificationStack.shift()
        }
        notificationStack = $notifications
      }, duration)
    // stop interval if hovering
    } else if (isHoveringOver) {
      clearInterval(removeNotifications)
      intervalStarted = false
    }
  // stop interval when stack is empty
  } else {
    clearInterval(removeNotifications)
    intervalStarted = false
  }

  function handleNotificationClick (notification) {
    if (!notification.link) {
      return
    }

    platform.router.push(notification.link)
  }

  function handleMouseOver () {
    isHoveringOver = true
  }

  function handleMouseLeave () {
    isHoveringOver = false
  }

  // send notification to the stack
  function sendNotification ({ id, notDismissable, type, message, link = '', icon = '', thumbnail = '' }) {
    $notifications = [...$notifications, { type, message, notDismissable, id: id || platform.api.core.uuid(), link, icon, thumbnail }]
    notificationStack = $notifications
    if ($notifications.length > 1 && message === $notifications[$notifications.length - 1].message) {
      removeNotification($notifications[$notifications.length - 2].id)
    }
  }

  function removeNotification (notification) {
    $notifications = $notifications.filter((n) => n.id !== notification)
    notificationStack = $notifications
  }

  function getClass (type) {
    switch (type) {
      case 'success':
        return `jolojo-notification__success`
      case 'error':
        return `jolojo-notification__error`
      case 'warning':
        return `jolojo-notification__warning`
      default:
        return `jolojo-notification__default`
    }
  }

  function getPositionClass (type) {
    switch (type) {
      case 'bottomRight':
        return `bottom-2 right-2`
      case 'bottomCenter':
        return `bottom-2 left-1/2 transform -translate-x-1/2`
      case 'bottomLeft':
        return `bottom-2 left-2`
      case 'topRight':
        return `top-2 right-2`
      case 'topCenter':
        return `top-2 left-1/2 transform -translate-x-1/2`
      case 'topLeft':
        return `top-2 left-2`
      default:
        return `bottom-2 right-2`
    }
  }

  // reset the store and stack in case
  // the component is mounted on a new page
  // and there still are some active notifications
  // that need to be reset
  onMount(() => {
    if (notificationStack.length > 0) {
      notificationStack = []
      $notifications = notificationStack
    }
  })
</script>

<style lang='scss'>#jolojo-notifications {
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  position: fixed;
  z-index: 999999;
  pointer-events: none;
}
@media (max-width: 992px) {
  #jolojo-notifications {
    bottom: unset;
    top: 10px;
  }
}

.jolojo-notification {
  position: relative;
  padding: 15px 25px;
  border-radius: 10px;
  margin: 10px 0px;
  pointer-events: auto;
}
@media (max-width: 992px) {
  .jolojo-notification {
    padding: 5px 15px;
  }
}

.jolojo-notification__close {
  position: absolute;
  cursor: pointer;
  top: -10px;
  right: -10px;
  width: 1.65rem;
  height: 1.7rem;
  padding: 3px;
  background: white;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  color: rgb(36, 36, 36);
  border-radius: 50%;
  pointer-events: auto;
}

.jolojo-notification__close svg {
  height: 1.25rem;
  width: 1.25rem;
}

.jolojo-notification__success {
  background: #7fce87;
  border: 1px solid #addeb2;
}

.jolojo-notification__success:hover {
  background-color: #a5e8ac;
}

.jolojo-notification__warning {
  border: 1px solid rgb(230, 196, 138);
}

.jolojo-notification__warning:hover {
  background-color: #e0aa4d;
}

.jolojo-notification__error {
  border: 1px solid #c7433c;
}

.jolojo-notification__error:hover {
  background-color: #e16c66;
}

.jolojo-notification__default {
  border: 1px solid #7d7d7d;
}

.jolojo-notification__default:hover {
  background-color: #8c8c8c;
}

.cursor-pointer {
  cursor: pointer;
}

.spinner {
  animation: rotate 2s linear infinite;
  z-index: 2;
  width: 20px;
  height: 20px;
  z-index: 15;
}

.spinner-path {
  stroke: white;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}</style>
